import { update } from "lodash";

export const module_settings_view = () => ({
    components:{
        moduleForm
    }
});

function moduleForm(module){
    return {
        module,
        async updateModuleSettings($event){
            const { isConfirmed } = await Swal.fire({
                title: 'Actualizar configuración',
                text: `La configuración del ${this.module} será actualizada. ¿Continuar con la acción?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Actualizar',
                cancelButtonText: 'Cancelar'
            });

            if (!isConfirmed) return;

            const formData = new FormData($event.target);
            const jsonData = Object.fromEntries(formData.entries());

            try {
                const { data } = await axios.put(`/api/modules-settings/${this.module}`, jsonData);

                this.$dispatch('add-toast', {
                    type: 'success',
                    title: 'Configuración actualizada',
                    text: `Se ha actualizado la configuración del <strong>${this.module}</strong>`
                });

                console.log('data', data);
            } catch (error) {
                this.$dispatch('add-toast', {
                    type: 'error',
                    title: 'Fallo al actualizar configuración',
                    text: 'Unespected error. See console for more details.'
                });
            }
        }
    }
}
